export const formatDateOnlyString = (parseableDateString?: string): string => {
    if (!parseableDateString) return "";

    return new Date(parseableDateString).toLocaleDateString();
};

export const formatTimeOnlyString = (parseableDateString?: string): string => {
    if (!parseableDateString) return "";

    return new Date(parseableDateString).toLocaleTimeString();
};

export const formatDateTimeString = (parseableDateString?: string): string => {
    if (!parseableDateString) return "";

    return `${formatDateOnlyString(parseableDateString)} ${formatTimeOnlyString(
        parseableDateString
    )}`;
};
